import React, { Component } from "react";
import $ from "jquery";
import axios from "axios";
import { isGuid } from "../utils/utils";

export default class HeaderLogo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clientId: "",
      dealerName: "",
      dealerWebsite: "",
      dealerImgUrl: "",
      dealerPhoneNumber: "",
    };

    this.CheckQRCode();
  }

  async CheckQRCode() {
    const host = process.env.REACT_APP_API_BASE_URL;
    const clientId = this.props.urlData.clientId;
    const requestId = this.props.urlData.requestId;

    if (isGuid(clientId)) {
      await axios
        .get(
          `${host}/checkqrcode?RequestId=${requestId}&ClientId=${clientId}`,
          {
            headers: {
              "DAS-Guest-Subscription-Key":
                process.env.REACT_APP_API_SUBSCRIPTION_KEY, //the guest subscription key
            },
          }
        )
        .then((res) => {
          const responseData = res.data;

          if (
            responseData.reviewRequestId !== null &&
            isGuid(responseData.reviewRequestId)
          ) {
            window.location.href = `/?requestId=${responseData.reviewRequestId}&clientId=${responseData.clientId}`; //relative to domain
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  async GetDealer() {
    const host = process.env.REACT_APP_API_BASE_URL;
    const clientId = this.props.urlData.clientId;
    const requestId = this.props.urlData.requestId;

    if (isGuid(clientId)) {
      await axios
        .get(
          `${host}/accountinfo?RequestId=${requestId}&ClientId=${clientId}`,
          {
            headers: {
              "DAS-Guest-Subscription-Key":
                process.env.REACT_APP_API_SUBSCRIPTION_KEY, //the guest subscription key
            },
          }
        )
        .then((res) => {
          const dealerData = res.data;

          this.setState({
            clientId: dealerData.clientId,
            dealerName: dealerData.name,
            dealerWebsite: dealerData.website,
            dealerImgUrl: dealerData.headerImageUrl,
            dealerPhoneNumber: dealerData.phoneNumber,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  //Save the review request opened date.
  async OpenedDate() {
    const host = process.env.REACT_APP_API_BASE_URL;
    const clientId = this.props.urlData.clientId;
    const requestId = this.props.urlData.requestId;

    if (isGuid(requestId)) {
      const body = {};
      const headers = {
        "DAS-Guest-Subscription-Key":
          process.env.REACT_APP_API_SUBSCRIPTION_KEY,
      };

      await axios
        .post(
          `${host}/reviewrequestopened?RequestId=${requestId}&ClientId=${clientId}`,
          body,
          { headers }
        )
        .then((res) => {})
        .catch((error) => {
          console.log(error);
        });
    }
  }

  componentDidMount() {
    $("#loaderSpinnerMain").show();
    //Call the function to get the dealer information
    this.GetDealer();
    this.OpenedDate();
    $("#loaderSpinnerMain").hide();
  }

  render() {
    return (
      <div className="header-logo-image-container">
        <div id="loaderSpinnerMain" className="loader"></div>
        <div>
          <img alt={this.state.dealerName} src={this.state.dealerImgUrl}></img>
        </div>
        <div>
          <div className="header-logo-website-container">
            <a href={this.state.dealerWebsite} className="header-logo-text">
              {this.state.dealerWebsite}
            </a>
          </div>
          <div>
            <a
              href={"tel:" + this.state.dealerPhoneNumber}
              className="header-logo-text"
            >
              {this.state.dealerPhoneNumber}
            </a>
          </div>
        </div>
      </div>
    );
  }
}
